import { useState } from 'react';
import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';
import { Card } from '@/components/ui/card';
import { ChevronDown, ChevronUp } from 'lucide-react';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const employerFAQs = [
    {
      question: "Do I need to pay any payments to post job notifications?",
      answer: "No, we do not require any payment from you to post your job notifications. We are doing this as a social service to eradicate unemployment from the society."
    },
    {
      question: "Is this a paid consultancy firm?",
      answer: "No, we are doing this as a social service. This is purely a non-commercial firm."
    },
    {
      question: "Can I get the job seeker's profiles in all categories from this service?",
      answer: "Of course, you will get profiles from all categories. It is based upon the requirements you are posting. If you are posting different types of job profiles, you will get suitable responses from candidates."
    },
    {
      question: "How can I get suitable candidate profiles using this service?",
      answer: "In our society, many skilled candidates exist without proper guidance to search for suitable jobs. Most existing job portals require cost from the employer side, but we provide this service in a non-commercial manner. We already have skilled candidate profiles in our database. When you post your notifications, you can filter suitable registered job seeker profiles in our portal."
    },
    {
      question: "Are you doing this service only domestically or internationally too?",
      answer: "As of now, we are operating domestically. In future, we may extend if demand occurs."
    },
    {
      question: "Will you be able to organize exclusive job drives/job fairs for our firm?",
      answer: "Yes, we do organize job drives, pool campus drives, and job fairs exclusively. The expenses for events we organize have to be taken care of from your side. We support maximum reachability."
    },
    {
      question: "How are you doing this service without commercializing it?",
      answer: "We are working under a registered trust platform in India. Our only mission is to cure unemployment from society. We are also ready to receive sponsorships from socially-minded people to run our service efficiently."
    },
    {
      question: "Do you prefer/entertain paid consultancies?",
      answer: "No, we follow strict restriction policies and procedures not to entertain paid consultancies (those getting payments from both candidates and employers). We do not prefer them at any cost."
    },
    {
      question: "Do you have professional links with educational bodies?",
      answer: "Yes, we have professional links with educational bodies (Colleges, Universities, Business Schools) to create awareness about our services to final year students through job awareness programs and career guideline programs."
    },
    {
      question: "Can I get Skilled, Semi-skilled, Un-skilled profiles?",
      answer: "Yes, you will get Skilled, Semi-skilled, and Un-skilled profiles based upon your requirements posted on social media."
    },
    {
      question: "How many job requirements can I post?",
      answer: "INFINITY - you can post any number of job notifications as per your requirement."
    },
    {
      question: "How are you different from other employment service providers?",
      answer: "Cost involvement is the major difference. Also, the response rate is very high once you post your requirement through our service. We post your Job Description (JD) to all our NGO-following Job Seekers, and our job posts are widely shared by other NGOs, Volunteers, etc."
    }
  ];

  const jobSeekerFAQs = [
    {
      question: "Do I need to pay any payments to get job alerts?",
      answer: "No, we don't charge any payments from candidates, companies, or anyone else. We are doing this as a social service."
    },
    {
      question: "What time do I get job notifications daily?",
      answer: "Daily between 9:15 AM to 10:30 AM you will receive job notifications."
    },
    {
      question: "How can I add my friend/relative's number to this WhatsApp group?",
      answer: "Ask them to register on vvvsi.com through Job Seeker registration, as you have done."
    },
    {
      question: "What credentials and information do I need to submit?",
      answer: "You need to submit all the credentials and information present in your resume/biodata."
    },
    {
      question: "Is this a paid consultancy firm?",
      answer: "No, we are not a consultancy. We are doing this as a social service under a registered trust platform in India."
    },
    {
      question: "Do I need to pay for the companies whose jobs I'm getting?",
      answer: "No, you don't have to pay the companies. We only approve reputed job notifications received directly from company HRs, Directors, and Owners."
    },
    {
      question: "Can I get job notifications in all job categories?",
      answer: "Yes, you can find job notifications from all categories by filtering according to your qualification and experience."
    },
    {
      question: "What is the qualification range to benefit from this service?",
      answer: "We provide services to people with any kind of qualification (even illiterate people). Our qualification range includes 10th, 12th, ITI, Diploma, UG degree, PG Degree, Engineering UG & PG, Doctorate Degree in all streams, and others."
    },
    {
      question: "Will you provide international job opportunities?",
      answer: "As of now, we are not providing international job opportunities. In future, we may provide them depending on demand."
    },
    {
      question: "Is registration important to get job alerts?",
      answer: "Yes, registration is very important. Based on your registration, we will provide the Job Update WhatsApp Group link."
    },
    {
      question: "Do you prefer/entertain paid consultancies?",
      answer: "No, we do not entertain paid consultancies who demand payments from either candidates or employers."
    },
    {
      question: "How many days will it take to get a suitable job for me?",
      answer: "It depends on your skills, accuracy of details provided during registration, and various metrics from the employer side like prioritization, location, salary negotiation, etc."
    },
    {
      question: "Can I share your job notifications to my friends?",
      answer: "It is very appreciable if you share our notifications. Because of you, someone may benefit in their career."
    },
    {
      question: "Will you refer me to employers to get a job?",
      answer: "We do not provide any reference. We only provide guidance and path to get a suitable job for your profile. Selection is based on the employer's decision. If your skills match the job requirements, you will be selected."
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const FAQItem = ({ faq, index, globalIndex }) => (
    <div className="border-b border-slate-200 last:border-b-0">
      <button
        className="w-full py-4 px-4 flex justify-between items-center text-left hover:bg-slate-50 transition-colors"
        onClick={() => toggleFAQ(globalIndex)}
      >
        <span className="font-medium text-slate-900 pr-4">{faq.question}</span>
        {openIndex === globalIndex ? (
          <ChevronUp className="w-5 h-5 text-teal-600 flex-shrink-0" />
        ) : (
          <ChevronDown className="w-5 h-5 text-slate-400 flex-shrink-0" />
        )}
      </button>
      {openIndex === globalIndex && (
        <div className="px-4 pb-4">
          <p className="text-slate-600 text-sm leading-relaxed">{faq.answer}</p>
        </div>
      )}
    </div>
  );

  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-50 via-slate-50 to-white flex flex-col">
      <Header />

      <main className="flex-1">
        {/* Hero Section */}
        <div className="bg-gradient-to-r from-teal-600 to-teal-700 text-white py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h1 className="text-4xl md:text-5xl font-bold mb-4" style={{ fontFamily: 'Outfit' }}>
              Frequently Asked Questions
            </h1>
            <p className="text-xl text-teal-100 max-w-3xl">
              Find answers to common questions about our services for both employers and job seekers.
            </p>
          </div>
        </div>

        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          {/* For Employers */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold text-slate-900 mb-6" style={{ fontFamily: 'Outfit' }}>
              For Employers
            </h2>
            <Card className="border-slate-200 overflow-hidden">
              {employerFAQs.map((faq, index) => (
                <FAQItem key={index} faq={faq} index={index} globalIndex={index} />
              ))}
            </Card>
          </div>

          {/* For Job Seekers */}
          <div>
            <h2 className="text-2xl font-bold text-slate-900 mb-6" style={{ fontFamily: 'Outfit' }}>
              For Job Seekers
            </h2>
            <Card className="border-slate-200 overflow-hidden">
              {jobSeekerFAQs.map((faq, index) => (
                <FAQItem 
                  key={index} 
                  faq={faq} 
                  index={index} 
                  globalIndex={employerFAQs.length + index} 
                />
              ))}
            </Card>
          </div>

          {/* Contact Section */}
          <Card className="mt-12 p-8 border-slate-200 bg-gradient-to-br from-teal-50 to-white text-center">
            <h3 className="text-xl font-bold text-slate-900 mb-3" style={{ fontFamily: 'Outfit' }}>
              Still Have Questions?
            </h3>
            <p className="text-slate-600 mb-4">
              If you couldn't find the answer you're looking for, feel free to contact us.
            </p>
            <p className="text-teal-600 font-medium">
              Email: info@vvvsi.com | Phone: +91 82705 27992
            </p>
          </Card>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default FAQ;
